import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Menu, X, Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { name: 'Resume', path: '/' },
    { name: 'Projects', path: '/projects' },
    { name: 'Papers', path: '/papers' },
  ];

  const socialLinks = [
    { icon: Linkedin, href: 'https://www.linkedin.com/in/david-lukin/', label: 'LinkedIn' },
  ];

  const renderNavLink = (item) => (
    <NavLink
      key={item.path}
      to={item.path}
      onClick={() => setIsOpen(false)}
      className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
    >
      {item.name}
    </NavLink>
  );

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="brand" onClick={() => setIsOpen(false)}>
          <span className="brand-mark">DL</span>
          <span className="brand-text">
            <strong>David Lukin</strong>
            <span>Marketing Strategy</span>
          </span>
        </Link>

        <div className="nav-links desktop-only">
          {navItems.map(renderNavLink)}
        </div>

        <div className="social-links desktop-only">
          {socialLinks.map((social) => {
            const Icon = social.icon;
            return (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label={social.label}
              >
                <Icon size={19} />
              </a>
            );
          })}
        </div>

        <button
          type="button"
          onClick={() => setIsOpen((value) => !value)}
          className="menu-button"
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="mobile-panel"
        >
          {navItems.map(renderNavLink)}
          <div className="mobile-socials">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.label}
                >
                  <Icon size={19} />
                </a>
              );
            })}
          </div>
        </motion.div>
      )}
    </nav>
  );
}
